<template>
  <div class="create-card">
    <div class="content" :class="{ motion: motion }" @click="handleClick">
      <div class="create">
        <iconpark-icon
          name="plus-circle-fill"
          class="plus"
          size="32"
        ></iconpark-icon>
        <div v-if="description" class="description">
          {{ description || $t('xin-jian') }}
        </div>
        <slot name="extra" />
      </div>
      <div v-if="$slots.top && $slots.bottom" class="active">
        <a-spin :spinning="loading">
          <div class="top-content">
            <slot name="top"></slot>
          </div>
          <div class="bottom-content">
            <slot name="bottom"></slot>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
const { $t } = useNuxtApp()

export interface ICreateCard {
  description?: string
  motion?: boolean
  loading?: boolean
}

withDefaults(defineProps<ICreateCard>(), {
  // description: $t('xin-jian'),
  motion: false,
  loading: false,
})

const emit = defineEmits(['click'])

const slots = useSlots()

const handleClick = () => {
  if (!slots?.top) {
    emit('click')
  }
}
</script>
<style lang="scss" scoped>
.create-card {
  @apply w-full h-full;

  .content {
    @apply w-full h-full bg-back-2 rounded-[10px] relative border-[1px] border-dashed border-back-5 overflow-hidden transition-all;

    .create {
      @apply flex justify-center items-center flex-col w-full h-full text-center cursor-pointer;
      transition: all 0.3s linear;

      .plus {
        @apply text-primary mb-[16px];
      }

      .description {
        @apply text-14 text-font-1 font-medium;
      }
    }

    .active {
      @apply absolute inset-0 flex flex-col w-full h-full;
      transition: all 0.3s linear;

      .top-content,
      .bottom-content {
        @apply w-full h-1/2 opacity-0 flex justify-center items-center;
        transition: all 0.3s linear;
      }

      .top-content {
        background-color: var(--back-3);
        transform: translate(0, 100%);

        &:hover {
          transform: scale(1.15) !important;
        }
      }

      .bottom-content {
        background-color: var(--back-2);
        transform: translate(0, -100%);

        &:hover {
          transform: scale(1.15) !important;
        }
      }
    }

    &.motion {
      &:hover {
        .active {
          .top-content,
          .bottom-content {
            opacity: 1;
            transform: translate(0, 0);
          }
        }
      }
    }
  }
}
</style>
